import { RestService, Rest } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { BrandDto } from '../dtos/models';

@Injectable({
  providedIn: 'root',
})
export class BrandService {
  private readonly restService = inject(RestService);
  apiName = 'Default';
  

  getAll = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, BrandDto[]>({
      method: 'GET',
      url: '/api/app/brand',
    },
    { apiName: this.apiName,...config });
}